<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box">
      <div class="list-box-col">
        <p class="list-box-col__title">月份</p>
        <p class="list-box-col__content" v-for="item in result.monthitems" :key="item.text">{{ item.text }}</p>
        <!-- <p class="list-box-col__content">本年累计</p> -->
      </div>
      <div class="list-box-col list-box-active">
        <p class="list-box-col__title">平均库存天数</p>
        <p class="list-box-col__content" style="color: #2eadf5;" v-for="item in result.monthitems" :key="item.text">{{ item.amount || 0 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import F2 from '@antv/f2/lib/index';
import ScrollBar from '@antv/f2/lib/plugin/scroll-bar';
import '@antv/f2/lib/interaction/pan';

export default {
  data() {
    let year = new Date().getFullYear()

    return {
      result: {
        details: [],
        monthitems: []
      },
      year,
      opened: true,
      chart: null,
    };
  },
  mounted() {
    this.getArDays()
  },
  methods: {
    getArDays() {
      let me = this

      const params = {
        year: me.year
      }

      me.$ajax({
        url: "/api/money/ardays/list",
        params
      }).then(function (res) {
        if (res.success) {
          me.result = res.data
          me.initChart(me.deal(me.result.monthitems))
        }
      });
    },
    initChart(data) {
      let el = this.$el.querySelector(".myChart");
      el.style.width = "100%";
      el.style.height = "300px";
      
      // 初始化图表
      if (this.chart) {
        this.chart.clear();
      } else {
        this.chart = new F2.Chart({
          id: "myChart",
          pixelRatio: window.devicePixelRatio,
          plugins: ScrollBar,
        });
      }

      this.chart.source(data, {
        month: {
          min: 0,
          max: 7,
          tickInterval: 1,
          formatter: function(i) {
            return data[i-1]?.text || ''
          }
        }
      });

      // antv-f2柱状图平移，靠后的数据项未正确显示，先渲染一遍折线图
      this.chart.line().position('month*amount').style({
        lineWidth: 1   //设置折线的粗细为0
      })

      this.chart.point().position('month*amount');

      data.forEach((item) => {
        if(item.amount) {
          this.chart.guide().text({
            position: [ item.month, item.amount ],
            content: item.amount,
            style: {
              fill: '#808080',
              textAlign: 'center'
            },
            offsetY: -15
          })
        }
      })

      this.chart.interaction('pan');
      // 定义进度条
      this.chart.scrollBar({
        mode: 'x',
        xStyle: {
          backgroundColor: '#e8e8e8',
          fillerColor: '#808080',
          offsetY: -2
        }
      });

      this.chart.render();
    },
    deal(data) {
      data.forEach((item, index) => {
        item.month = ++index
      })

      return data
    },
    open() {
      this['opened'] = !this['opened']
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = []
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        {
          title: "选择年份",
          defaultValue: [year],
          onConfirm: function (r) {
            me.year = r[0].value
            me.getArDays()
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.canvas-box {
  /* width: 200%; */
  overflow-x: scroll;
  /* height: 100%; */
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option{
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}
.list-box-col {
  text-align: center;
}
.list-box-col p {
  line-height: 40px;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}
.list-box-active:active {
  background: #e0e0e0;
}
</style>